import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import ModalExportarImprimirPlaning from '../../components/planing/ModalExportarImprimirPlaning'
import {cerrarModalExportarImprimirPlaning, exportarPlaning, imprimirPlaning, imprimirZebraVerracos} from '../../actions/planing/planing'
import {comboVerraco} from '../../actions/combos/combos'

export function mapStateToProps (state) {
  return {
    ...state.planing,
    numeroRegistrosPorPagina: state.common.numeroRegistrosPorPagina,
    paginaActual: state.common.paginaActual,
    formSimpleTable: state.form.simpleTable,
    auth: state.auth,
    combos: state.combos
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      cerrarModalExportarImprimirPlaning,
      comboVerraco,
      imprimirZebraVerracos,
      exportarPlaning,
      imprimirPlaning
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ModalExportarImprimirPlaning))